import {useSelector} from 'react-redux';
import React from 'react';
import {UseFormReturn} from 'react-hook-form';
import {useTranslation} from 'react-i18next';
import {PresentationSettingsFormType} from '../../../../../incase-domain/validators/presentation/presentationSchema';
import {loggedInUserSelector} from '../../../../../store/selectors/auth.selectors';
import PresentationSharedPresentationsSettingsForm from '../../../../../components/presentation/settings/PresentationSharedPresentationsSettingsForm';

interface CollaborateSettingsProps {
    useForm: UseFormReturn<PresentationSettingsFormType>;
}

function CollaborateSettings({useForm}: CollaborateSettingsProps): JSX.Element {
    const {t} = useTranslation();

    const {watch} = useForm;
    const presentation = watch('presentation');

    const loggedInUser = useSelector(loggedInUserSelector);

    return (
        <div>
            <div className="c-verticalNavigation__header">
                <div className="c-verticalNavigation__header_title">{t('presEditPage.settings.sharedPresentations.header')}</div>
            </div>
            {presentation.userId === loggedInUser?._id && <PresentationSharedPresentationsSettingsForm presentation={presentation} />}
        </div>
    );
}

export default CollaborateSettings;
